import onCodeEditorChange from 'Functions/on-code-editor-change'
import { throttle } from 'lodash'
import { optimizeCodeWithPostCSS } from 'Functions/on-option-change'

const CodeManager = {
	codeTextarea: false,
	codeStyleBlock: false,

	/**
	 * Fires every time the content of the editor is changed.
	 * The changeObj is a {from, to, text, removed, origin} object
	 * containing information about the changes that occurred
	 * as second argument.
	 *
	 * – from and to are the positions (in the pre-change coordinate system)
	 * where the change started and ended
	 * (for example, it might be {ch:0, line:18} if the position
	 * is at the beginning of line #19).
	 *
	 * – text is an array of strings representing the text that replaced
	 * the changed range (split by line).
	 *
	 * – removed is the text that used to be between from and to,
	 * which is overwritten by this change. This event is fired before
	 * the end of an operation, before the DOM updates happen.
	 */

	throttledOnCodeEditorChange: throttle(
		function( instance ) {
			onCodeEditorChange( instance )
		}, 1000
	), // 1000 – delay in ms. before typed CSS changes aplly.

	getCode: () => {
		let cssCode = this.codeTextarea.value
		if ( undefined === cssCode ) {
			cssCode = ''
		}
		return cssCode
	},

	setCode: ( newValue ) => {
		this.codeTextarea.value = newValue
		CodeManager.throttledOnCodeEditorChange()
		this.codeStyleBlock.innerHTML = ''
	},

	init: () => {
		this.codeTextarea = document.getElementById( "stylist-css-code" )
		this.codeStyleBlock = window.Stylist.iDoc.getElementById( 'stylist' )

		// Before initalizing codeEditor, fill the text are with css from <style id="stylist">
		if ( null !== this.codeStyleBlock ) {
			this.codeTextarea.value = this.codeStyleBlock.innerHTML
		}

		/**
		 * Convert styles in textarea #stylist-css-code into
		 * inline style block #stlst-css-data-full on editor init.
		 * Important: this function should follow codeEditor.on( 'change' ) block
		 * otherwise it will not work.
		 */
		optimizeCodeWithPostCSS( CodeManager.getCode() ).then( ( response ) => {
			document.getElementById( 'stlst-preloader' ).remove()
		} )
	}

	/* window.Stylist.codeManager = {}

		window.Stylist.codeManager.getValue = () => {
			// const codeTextarea = document.getElementById( "stylist-css-code" )
			return codeTextarea.value
		}

		window.Stylist.codeManager.setValue = ( newValue ) => {
			// const codeTextarea = document.getElementById( "stylist-css-code" )
			codeTextarea.value = newValue
			throttledOnCodeEditorChange( this )
		}

		window.Stylist.codeManager.clearHistory = () => {

		} */
}

export default CodeManager



// WEBPACK FOOTER //
// ./dev/stylist_parent/functions/code-manager.js